export default "__VITE_ASSET__F$lkFKuL__"